import type { InterventionsBatchAssignOptions } from "./interventions-batch-assign.type";
import type { ApiEmptyResponse, ApiError } from "@/services/api";
import type { QueryInvalidateTarget } from "@/services/query";

import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";
import { useMutationOnSuccess } from "@/services/query";

export const useInterventionsBatchAssign = (
  interventions: number[],
  options?: InterventionsBatchAssignOptions
) => {
  const defaultInvalidate: QueryInvalidateTarget[] = [
    ["interventions", "list"],
    ...interventions.map((id) => ["interventions", "get", id]),
  ];

  const onSuccess = useMutationOnSuccess({ ...options, defaultInvalidate });

  const mutationFn = (users: number[]) => {
    return client.interventions.batch.assign({ interventions, users });
  };

  return useMutation<ApiEmptyResponse, ApiError, number[]>({
    mutationFn,
    onSuccess,
  });
};
